<template>
    <div class="msg">
        <div class="board-title">信息中心</div>
        <!-- 标为已读 -->
        <div class="msg-readtag">
            <veui-button ui="basic l" @click="toSetRead">
                全部标为已读
            </veui-button>
        </div>
        <div>
            <div class="msg-motify"><div class="msg-motify-text">通知</div></div>
            <div>
                <div
                    v-for="(item, index) in list"
                    :key="index"
                    class="msg-item"
                    :class="{'read': item.is_read === 1}"
                >
                    <!--bca-disable-next-line-->
                    <div v-html="item.msg_info && item.msg_info.content"></div>
                    <div class="msg-item-time">{{ dateFormat('yyyy.MM.dd', item.create_time) }}</div>
                </div>
            </div>
            <veui-pagination
                v-if="rn > 20"
                class="pagination"
                :page="pn"
                :page-size.sync="rn"
                :total="total"
                @redirect="getData"
            />
        </div>
        <div v-if="list.length === 0" class="empty">
            <img src="../../../assets/img/law/emtpy.png" alt="">
        </div>
    </div>
</template>

<script>
/**
 * @file index.vue
 * @desc 工具绑定
 * @author <liujiaojiao01@baidu.com>
*/

import {mapMutations} from 'vuex';
import {Pagination, Button} from 'veui';
import mixinajax from '@/mixins/ajax';
import util from '../util/util';
const url = {
    // 消息列表
    listMsg: '/bp/api/msg/listMsg',
    setRead: '/bp/api/msg/setread',
    statisticsMsg: '/bp/api/msg/statistics'
};

export default {
    name: 'msg',
    mixins: [mixinajax],
    components: {
        'veui-button': Button,
        'veui-pagination': Pagination
    },
    data() {
        return {
            pn: 1, // 页数
            rn: 20, // 每页多少个-默认20
            total: 0,
            list: []
        };
    },
    created() {
        this.getData();
        this.getStatistics();
    },
    methods: {
        dateFormat: util.dateFormat,
        ...mapMutations({
            setStatistics: 'Statistics/setStatistics'
        }),
        // 消息统计信息
        getStatistics() {
            this.ajaxGet(url.statisticsMsg)
                .then(res => {
                    if (!res || +res?.code !== 0) {
                        res.msg && this.$Message.error({
                            content: res.msg,
                            duration: 5
                        });
                        return;
                    }
                    const data = res?.data || {};
                    if (data) {
                        this.setStatistics(data);
                    }
                })
                .catch(error => {
                    this.$Message.error({
                        content: error.msg || '数据请求出错',
                        duration: 5
                    });
                });
        },
        getData(page = 1) {
            this.pn = page;
            this.ajaxGet(url.listMsg, {
                params: {
                    pn: this.pn,
                    rn: this.rn
                }
            }).then(res => {
                if (!res || +res.code !== 0) {
                    this.$Message.error({
                        content: res?.msg || '数据请求出错',
                        duration: 5
                    });
                    return;
                }
                const data = res?.data;
                if (data) {
                    this.list = data.list;
                    this.total = data.total;
                }
            }).catch(error => {
                this.$Message.error({
                    content: error.msg || '数据请求出错',
                    duration: 5
                });
            });
        },
        toSetRead() {
            this.ajaxPost(url.setRead)
                .then(res => {
                    if (!res || +res?.code !== 0) {
                        this.$Message.error({
                            content: res?.msg || '数据请求出错',
                            duration: 5
                        });
                        return;
                    }
                    const data = res?.data;
                    if (data) {
                        this.$Message.success('全部标记已读成功');
                        this.getStatistics();
                        this.getData();
                    }
                })
                .catch(error => {
                    this.$Message.error({
                        content: error.msg || '数据请求出错',
                        duration: 5
                    });
                });
        }
    }
};

</script>

<style lang="stylus" scoped>
  .msg
      position relative
      background #fff
      padding 24px
      height calc(100vh - 130px)
      overflow: scroll
      .unread
        color
      .msg-readtag
          position absolute
          top 24px
          right 24px
      .msg-item
          padding 16px 0 16px 0
          font-size 14px
          color #282C33
          display flex
          justify-content space-between
          border-bottom 1px solid #E2E6F0
          .msg-item-time
              color: #848B99
      .read
        color #848B99
      .msg-motify
          line-height 44px
          border-bottom 1px solid #E2E6F0
          margin-top 5px
          .msg-motify-text
              width 88px
              color: #0052CC;
              text-align center
              border-bottom 2px solid #0052CC
      .empty
        margin 160px 0
        img
            margin 0 auto
            display block

.board-title
    font-size: 20px
    color: #282C33
    font-weight 700
.pagination
    display flex
    justify-content flex-end;
    margin-top 16px
/deep/ .veui-pagination-size
    display none

</style>
